import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X, CalendarDays } from 'lucide-react';
import { Logo } from '../../constants';

// Header Component
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header 
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'backdrop-blur-xl bg-[#05050A]/90 border-b border-white/10' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Logo />
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {[
              { label: 'Služby', id: 'services' },
              { label: 'Galéria', id: 'gallery' },
              { label: 'Rezervácia', id: 'booking' },
              { label: 'Cenník', id: 'pricing' },
              { label: 'FAQ', id: 'faq' },
              { label: 'Kontakt', id: 'contact' },
            ].map((item) => (
              <button
                key={item.id}
                data-testid={`nav-${item.id}`}
                onClick={() => scrollToSection(item.id)}
                className="text-zinc-400 hover:text-white transition-colors text-sm font-medium"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/blog"
              data-testid="nav-blog"
              className="text-zinc-400 hover:text-white transition-colors text-sm font-medium"
            >
              Blog
            </Link>
          </nav>

          {/* CTA Button */}
          <a
            href="#booking"
            data-testid="header-cta"
            className="hidden md:flex items-center gap-2 bg-[#00BFFF] text-[#05050A] px-6 py-2.5 font-semibold hover:bg-[#33CCFF] transition-all hover:shadow-[0_0_20px_rgba(0,191,255,0.4)]"
          >
            <CalendarDays size={18} />
            Rezervovať
          </a>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#05050A]/95 backdrop-blur-xl border-t border-white/10">
          <nav className="flex flex-col p-6 gap-4">
            {[
              { label: 'Služby', id: 'services' },
              { label: 'Galéria', id: 'gallery' },
              { label: 'Rezervácia', id: 'booking' },
              { label: 'Cenník', id: 'pricing' },
              { label: 'FAQ', id: 'faq' },
              { label: 'Kontakt', id: 'contact' },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-zinc-400 hover:text-white transition-colors text-left py-2"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/blog"
              className="text-zinc-400 hover:text-white transition-colors text-left py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <a
              href="tel:+421915264064"
              className="flex items-center justify-center gap-2 bg-[#00BFFF] text-[#05050A] px-6 py-3 font-semibold mt-4"
            >
              <Phone size={18} />
              Zavolajte nám
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
